/**
 * Reposition SA Request a Quote "Add to Quote" button below Buy it now.
 * The app embed injects after Add to Cart; this moves the node after
 * .product-form__express / .shopify-payment-button.
 */
(() => {
  const SCOPE_SELECTORS = ['.custom-buy-buttons', 'product-form.product-form', '.product-form'];
  const ANCHOR_SELECTORS = [
    '.product__payment-icons',
    '.product-form__express',
    '.shopify-payment-button',
    '[data-shopify="payment-button"]',
  ];
  const QUOTE_SELECTORS = [
    '[class*="add-to-quote" i]',
    '[id*="add-to-quote" i]',
    '[class*="add_to_quote" i]',
    '[id*="add_to_quote" i]',
    '[class*="request-a-quote" i]',
    '[id*="request-a-quote" i]',
    '[class*="request_a_quote" i]',
    '[class*="sa-request" i]',
    '[class*="sa_request" i]',
    '[class*="smt-rq" i]',
    '[class*="smt_rq" i]',
    '[class*="rfq-btn" i]',
    '[class*="rfq_btn" i]',
    '[class*="btn-rfq" i]',
    '[data-sa-rfq]',
    '[data-rfq]',
  ];
  const QUOTE_TEXT = /add\s*to\s*quote|request\s*(a\s*)?quote/i;
  const SKIP_TEXT = /add\s*to\s*cart|buy\s*it\s*now|sold\s*out|unavailable/i;
  const STRUCTURAL =
    '.product-form__buttons, .buy-controls-row, .buy-controls-row__submit, .form, .custom-buy-buttons, product-form, form';
  const IGNORE =
    '.product-form__submit, [name="add"], .shopify-payment-button, [data-shopify="payment-button"], .main-product-extra-button, .main-product-extra-button-wrapper, .quantity, .quantity__button, .loading-overlay, .loading__spinner';

  const moved = new WeakSet();

  function scopes(root = document) {
    const found = [];
    SCOPE_SELECTORS.forEach((sel) => {
      root.querySelectorAll(sel).forEach((el) => {
        if (!found.includes(el)) found.push(el);
      });
    });
    return found;
  }

  function isIgnorable(el) {
    return !el || el.nodeType !== 1 || el.matches(IGNORE);
  }

  function matchesQuoteText(el) {
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || SKIP_TEXT.test(text)) return false;
    return QUOTE_TEXT.test(text);
  }

  function collectQuoteElements(scope) {
    const set = new Set();

    QUOTE_SELECTORS.forEach((sel) => {
      try {
        scope.querySelectorAll(sel).forEach((el) => {
          if (!isIgnorable(el)) set.add(el);
        });
      } catch (_) {
        /* ignore unsupported selector syntax */
      }
    });

    scope.querySelectorAll('button, a, [role="button"], input[type="button"]').forEach((el) => {
      if (!isIgnorable(el) && matchesQuoteText(el)) set.add(el);
    });

    return [...set];
  }

  function nodeToMove(el, scope) {
    let node = el;
    while (node.parentElement && node.parentElement !== scope) {
      const parent = node.parentElement;
      if (parent.matches(STRUCTURAL)) break;
      if (parent.children.length === 1) {
        node = parent;
        continue;
      }
      break;
    }
    return node;
  }

  function insertionAnchor(scope) {
    for (const sel of ANCHOR_SELECTORS) {
      const el = scope.querySelector(sel);
      if (el) return el;
    }
    return scope.querySelector('.buy-controls-row');
  }

  function relocateInScope(scope) {
    const anchor = insertionAnchor(scope);
    if (!anchor) return;

    const parent = anchor.parentElement;
    if (!parent) return;

    collectQuoteElements(scope).forEach((el) => {
      const target = nodeToMove(el, scope);
      if (!target || moved.has(target)) return;
      if (target === anchor || anchor.contains(target)) return;

      if (anchor.matches('.product__payment-icons')) {
        if (target.parentElement === parent && target.nextElementSibling === anchor) {
          target.classList.add('sa-quote-relocated');
          moved.add(target);
          return;
        }
        parent.insertBefore(target, anchor);
      } else {
        if (target.parentElement === parent && target.previousElementSibling === anchor) {
          target.classList.add('sa-quote-relocated');
          moved.add(target);
          return;
        }
        parent.insertBefore(target, anchor.nextSibling);
      }

      target.classList.add('sa-quote-relocated');
      moved.add(target);
    });
  }

  function run(root = document) {
    scopes(root).forEach(relocateInScope);
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      run();
    });
  }

  function init() {
    run();
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    document.addEventListener('shopify:section:load', () => run());
    document.addEventListener('shopify:section:reorder', () => run());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
